const Xero = () => {
  return (
    <div>
      <h1>Xero Integration</h1>
    </div>
  )
}

export default Xero